import { CONTACT_POINT_SYSTEM } from "utils/constants";
import * as yup from "yup";

const validation = (errors) => {
  const requiredString = yup
    .string()
    .typeError(errors.REQUIRED)
    .required(errors.REQUIRED);

  return yup.object().shape({
    // telecoms: yup.object().shape({
    //   [CONTACT_POINT_SYSTEM.ZIP_CODE]: yup.object().shape({
    //     value: yup
    //       .string()
    //       .typeError(errors.REQUIRED)
    //       .required(errors.REQUIRED)
    //       .matches(/^\d{5}$/, {
    //         message: errors.INVALID_VALUE,
    //         excludeEmptyString: true,
    //       }),
    //   }),
    // }),
  });
};

export default validation;
